import * as React from "react";
import {Link} from "react-router";
import {UserService, USER_SERVICE_NAME} from "../../service/admin/UserService";
import {AppCtx} from "../../ioc/ApplicationContext";
import {User} from "../../../generated/protocol";

export interface UserLinkPanelProps {
    userId: number | string;
    header: string;
}

interface State {
    user?: User;
    userId?: number;
}

export class UserLinkPanel extends React.Component<UserLinkPanelProps, State> {

    userService: UserService;

    constructor(props) {
        super(props);
        this.userService = AppCtx.resolve<UserService>(USER_SERVICE_NAME);
        this.state = {user: null, userId: props.userId};
        console.log("UserLinkPanel constructed with props ", props)
    }

    componentDidMount() {
        this.loadUser()
    }

    componentWillUpdate(nextProps, nextState) {
        nextState.userId = nextProps.userId
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.userId != prevProps.userId) {
            console.log("Load user ")
            this.loadUser()
        }
    }

    loadUser() {
        if (this.state.userId) {
            Promise.all([
                this.userService.getEntity("" + this.state.userId)
            ]).then(values => {
                this.setState({user: values[0]});
            }).catch(error => {
                this.setState({user: null});
            });
        }
    }

    render() {
        if (this.state.user == null) {
            return <div></div>
        }

        return (
            <div className="ibox">
                <div className="ibox-content">
                    <h2>{this.props.header}</h2>
                    <div className="feed-element">
                        <a href="" className="pull-left">
                            <img alt="image" className="img-circle" src={`${contextPath}/images/avatar-5.png`}/>
                        </a>

                        <div className="media-body ">
                            <Link to={"/user/" + this.state.user.userId}>
                                <div className="pull-right">
                                    <a className="btn btn-primary"><i className="fa fa-eye"></i> View </a>
                                </div>
                            </Link>
                            <strong>{this.state.user.attributes["externalUsername"]}</strong><br/>
                            <span
                                className="text-muted">{"ID: " + this.state.user.userId + ", Operator ID: " + this.state.user.externalUserId}</span>

                        </div>
                    </div>

                </div>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/app/ui/user/UserLinkPanel.tsx